import { useState, useContext, createContext, useEffect } from 'react';
import { constants } from '../config/constants';

const UserNameContext = createContext();

function UserNameProvider({ children }) {
  // eslint-disable-next-line no-unused-vars
  const [userName, setUserName] = useState('');
  const [userRole, setUserRole] = useState('');
  const [userId, setUserId] = useState(null);

  function ChangeUserName(name) {
    setUserName(name);
  }

  function setName(name) {
    localStorage.setItem(constants.USERNAME, name);
    setUserName(name);
  }
  function setRole(name) {
    localStorage.setItem(constants.ROLE, name);
    setUserRole(name);
  }

  function setId(id) {
    localStorage.setItem(constants.USER_ID, id);
    setUserId(id);
  }

  function clearCache() {
    localStorage.setItem(constants.USER_ID, null);
    setUserId(null);
    localStorage.setItem(constants.ROLE, null);
    setUserRole(null);
    localStorage.setItem(constants.USERNAME, null);
    setUserName(null);
  }

  useEffect(() => {
    const userName = localStorage.getItem(constants.USERNAME);
    if (userName) {
      ChangeUserName(userName.replace(/['"]+/g, ''));
    }
  }, [userName]);

  useEffect(() => {
    const role = localStorage.getItem(constants.ROLE);
    if (role) {
      setUserRole(role);
    }
  }, [userRole]);

  useEffect(() => {
    const uid = localStorage.getItem(constants.USER_ID);
    if (uid) {
      setId(uid);
    }
  }, [userId]);

  return (
    <UserNameContext.Provider
      value={{
        ChangeUserName,
        userName,
        setName,
        setRole,
        userRole,
        userId,
        setId,
        clearCache
      }}>
      {children}
    </UserNameContext.Provider>
  );
}

function useUserName() {
  const context = useContext(UserNameContext);
  if (!context) {
    throw new Error('useUserName must be used within a UserNameProvider');
  }
  return context;
}
export { UserNameProvider, useUserName };